import { Deployment, DeploymentFetchOptions } from "../models/types";
import queryClient, { QueryKey } from "../state/QueryStore";
import { ListResponse } from "../utilities/ApiResponseHelper";
import { DeploymentPermission } from "./../models/types";
import { httpGetAuthenticated, httpPatchAuthenticated, httpPostAuthenticated } from "./ApiService";

const endpoints = {
  list: () => "/deployments",
  retrieve: (id: string) => `/deployments/${id}`,
};

export const getDeployments = async (params: DeploymentFetchOptions) => {
  return httpGetAuthenticated<ListResponse<Deployment>>(endpoints.list(), {
    params,
  });
};

export const getDeployment = async (id: string) => {
  return httpGetAuthenticated<Deployment>(endpoints.retrieve(id));
};

export const createDeployment = async (payload: {
  name: string;
  description: string;
  runnable: string;
  read_permission: DeploymentPermission;
  edit_permission: DeploymentPermission;
  read_authorized_roles: string[];
  edit_authorized_roles: string[];
  variables_mapping: {
    secret: boolean;
    key: string;
    value: string;
  }[];
  guardrails_settings?: any;
}) => {
  const { data } = await httpPostAuthenticated<Deployment>(endpoints.list(), payload);
  queryClient.invalidateQueries({ queryKey: [QueryKey.Deployment] });
  return data;
};

export const editDeployment = async (
  deploymentId: string,
  payload: {
    name?: string;
    description?: string;
    status?: "active" | "inactive";
    read_permission?: DeploymentPermission;
    edit_permission?: DeploymentPermission;
    read_authorized_roles?: string[];
    edit_authorized_roles?: string[];
  }
) => {
  const { data } = await httpPatchAuthenticated(endpoints.retrieve(deploymentId), payload);
  queryClient.invalidateQueries({ queryKey: [QueryKey.Deployment, deploymentId] });
  return data;
};
